import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/service/event.service";
import { FilterBaseComponent } from "../filter-base-component";

@Component({
    selector: "app-filter-select",
    templateUrl: "./filter-select.component.html",
    styleUrls: ["./filter-select.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterSelectComponent
  extends FilterBaseComponent
  implements OnInit, OnDestroy
{
  public value: number;

  constructor(
    protected _eventService: EventService,
    protected _translateService: TranslateService
  ) {
    super(_eventService, _translateService);
  }

  ngOnInit(): void {
    if (this.Filter.InputValue !== "") {
      this.value = Number(this.Filter.InputValue);
      this.valueChanged(this.value);
    }
    this.baseSubscribeTranslationEvent();
    this.baseLoadTranslation();
  }

  ngOnDestroy(): void {
    this.baseOnDestroy();
  }

  /**
   * On ionBlur send value of filter
   */
  public valueChanged(event: any): void {
    this._eventService.OnFilterValueChanged.next([
      this.Filter,
      event == null ? "" : event.toString(),
    ]);
  }
}
